import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { Observable } from 'rxjs';

export function priceValidator(allowEmpty = false): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    if (allowEmpty && (control.value === null || control.value === '')) {
      return null;
    }

    const value = String(control.value).replace(/,/g, '');
    const valid = /^\d+(\.\d*)?$/.test(value) && parseFloat(value) >= 0;
    return valid ? null : { positiveNumber: { value: control.value } };
  };
}

export function upfrontAmountValidator(referenceControlName: string): ValidatorFn {
  return (control: any): ValidationErrors | null => {
    if (!control.parent || control.value === null || control.value === '') {
      return null;
    }

    const priceControl = control.parent.get(referenceControlName);
    if (!priceControl) {
      throw new Error(`Reference control '${referenceControlName}' not found.`);
    }

    const priceValue = parseFloat(String(priceControl.value).replace(/,/g, ''));
    const valueStr = String(control.value).replace(/,/g, '');
    const value = parseFloat(valueStr);
    if (!/^\d+(\.\d+)?$/.test(valueStr) || Number.isNaN(value)) {
      return null;
    }

    if (priceValue >= 25) {
      const maximumUpfrontAmountCents = Math.round(priceValue * 100) - 1000;
      const upfrontAmountCents = Math.round(value * 100);
      if (value !== 0 && (Number.isNaN(value) || upfrontAmountCents > maximumUpfrontAmountCents)) {
        return { maxPercentage: true };
      }
    }

    return null;
  };
}

export function siblingPriceNotEqualValidator(
  siblingPrices$: Observable<number[]>,
  componentIndex: number
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control || !control.value) {
      return null; // No validation for empty values
    }

    let isDuplicate = false;

    siblingPrices$.subscribe((siblingPrices) => {
      if (siblingPrices.length <= 1) {
        return null;
      }

      isDuplicate = siblingPrices.some((price, idx) => idx !== componentIndex && price === control.value);
    });

    return isDuplicate ? { notEqualSibling: true } : null;
  };
}
